import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { MDASH, MIDDOT } from '../../utility/constants';
// Inline styles: the invoice HTML is posted as-is to be rendered into the PDF, where app CSS is not loaded.
export default (props) => !props.notes.length ? null :
    _jsxs("span", { style: { 'fontSize': '.85em', 'fontStyle': 'italic' }, children: [` ${MDASH} `, props.notes.map((x) => x.note.trim()).join(` ${MIDDOT} `)] });
